/* eslint-disable max-lines */
//
// GENERATED FILE - DO NOT EDIT BY HAND.
// Source of truth: X:\Source\Admin\LNG\phrases.json
// Rebuild: . 'X:\Source\Admin\ReUsablePS\LNG\CreateProductLNGFile.ps1'; GetPhrasesFromFile '<PRODUCT>'; WritekLNGALL
// Skill:   X:\Source\Admin\AgentInstruction\skills\using-lng\SKILL.md
// Manual edits here are overwritten on the next build.
//
// The default export is GUARDED: reading a key this file does not declare reports to
// ks.KGlobalErrorHandler naming the key, instead of painting the string 'undefined'.
//
import { kLNGGuard } from "../../../Admin/ReUsableTS/kLNGGuard";
class LNG {
    public static SetLanguage = (Language: string): void => {}
    public static ADD = 'Add';
    public static ADDNEW = 'Add new';
    public static ALL = 'All';
    public static CANCEL = 'Cancel';
    public static CLEAR = 'Clear';
    public static CLOSE = 'Close';
    public static COPY = 'Copy';
    public static DAY = 'Day';
    public static DAYS = 'Days';
    public static DIAGRAM = 'Diagram';
    public static EDIT = 'Edit';
    public static EDITINFORM = 'Edit in form';
    public static EXPORT = 'Export';
    public static EXPORTTOEXCEL = 'Export to Excel';
    public static FILLDOWN = 'Fill Down';
    public static FILLRIGHT = 'Fill Right';
    public static FILTERADDCONDITION = 'Add condition';
    public static FILTERADVANCED = 'Advanced filter';
    public static FILTERAFTER = 'After';
    public static FILTERAPPLY = 'Apply';
    public static FILTERBEFORE = 'Before';
    public static FILTERBETWEEN = 'Between';
    public static FILTERBYTHISVALUE = 'Filter by this value';
    public static FILTERCLEAR = 'Clear';
    public static FILTERCLEARALLFILTERS = 'Clear all filters';
    public static FILTERCLEARTHISCOLUMN = 'Clear this column filter';
    public static FILTERCONTAINS = 'Contains';
    public static FILTERENDSWITH = 'Ends with';
    public static FILTEREQUALS = 'Equals';
    public static FILTERGREATEROREQUAL = 'Greater or equal';
    public static FILTERGREATERTHAN = 'Greater than';
    public static FILTERHEADING = 'Filter';
    public static FILTERISEMPTYOP = 'Is empty';
    public static FILTERISNOTEMPTY = 'Is not empty';
    public static FILTERLESSOREQUAL = 'Less or equal';
    public static FILTERLESSTHAN = 'Less than';
    public static FILTERMATCHALL = 'Match all conditions';
    public static FILTERNO = 'No';
    public static FILTERNOTEQUALS = 'Not equals';
    public static FILTERONDATE = 'On';
    public static FILTERS = 'Tagged events,Partially tagged events,Both tagged and partially tagged,Not tagged events,All events';
    public static FILTERSEARCHVALUES = 'Search values';
    public static FILTERSELECTALL = 'Select all';
    public static FILTERSTARTSWITH = 'Starts with';
    public static FILTERTHISCOLUMN = 'Filter this column';
    public static FILTERVALUELABEL = 'Value';
    public static FILTERYES = 'Yes';
    public static KUI_OPEN_ADVANCED_FILTER = 'Open advanced filter';
    public static NAME = 'Name';
    public static NEW = 'New ticket';
    public static NEXT = 'Next';
    public static OK = 'OK';
    public static OTHER = 'Other';
    public static PAGEOF = 'Page [X1] of [X2]';
    public static PASTE = 'Paste';
    public static PREVIOUS = 'Previous';
    public static REMOVE = 'Remove';
    public static SEARCH = 'Search';
    public static SELECT = 'Select';
    public static SELECTALL = 'Select all';
    public static SORTCOLUMNASC = 'Sort column asc.';
    public static SORTCOLUMNDESC = 'Sort column desc.';
}

export default kLNGGuard.Watch(LNG);

